import React, {useEffect, useRef, useState} from 'react';
import User from './img/profile.svg';
import Swal from 'sweetalert2';
import {t} from 'react-switch-lang';
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import {fetchUserApi, createComments} from '../../services/commentsService';
import {validCommentsRegex} from '../../utils/const';
import Toast from '../toast/Toast';
import {parseISO,format} from 'date-fns'
import UserAvatar from "../avatar/UserAvatar"
const AddComments = (props) => {

  const {id} = props;
  const [user, setUser] = useState([]);
  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState('');
  const commentFocus = useRef();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  let comments = {};
  let commentsCreate = true;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const {data: userData} = await fetchUserApi();
        setUser(userData);
      } catch (err) {}
    };
    fetchUser();
  }, []);

  const validateComment = () => {
      const trimmedComment = comment !== undefined && comment !== null ? comment.trim() : '';
      let isValid;
      if(trimmedComment === ''){
        setCommentError(t('message.fieldRequired'))
        isValid = false;
      }else if(trimmedComment.length < 3){
        setCommentError( t('message.min3'))
        isValid = false;
      }else if(trimmedComment.length > 1000){
        setCommentError( t('message.max1000'))
        isValid = false;
      }else if(!validCommentsRegex.test(trimmedComment)){
        setCommentError( t('message.fieldNotValid'))
        isValid = false;
      }else{
        setCommentError('')
        isValid = true;
      }
      return isValid;
  }

  const sendData = (formData) => {
    createComments(formData)
      .then((r) => {
        Toast.fire({
          icon: 'success',
          title: `${t('message.successAdd')}`,
        });
        // reset({defaultValues});
        props.commentAdded();
        
        setIsButtonDisabled(false);
      })
      .catch((r) => {
        Swal.fire({
          text: `${t('message.errorApi')}`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
        setIsButtonDisabled(false);
      });
  };

  const submitForm = (dateCreated) => {

    if (commentsCreate && validateComment()) {
      setIsButtonDisabled(true);
      // const getCurrentDate =  (dateCreated !== undefined) ? parseISO(format(dateCreated, "yyyy-MM-dd")) : undefined;

   
      const formAdd = {
        commentText: comment.trim(),
        // dateCreated: getCurrentDate,
        userId: user.id,
        userFirstName: user.userFirstName,
        userLastName: user.userLastName,
        // riskId: props.activeRisk,
        riskId: id,
      };
      sendData(formAdd);
      setComment('');
    } else {
      commentFocus.current.focus();
      if(!commentsCreate){
        setCommentError('You dont have permissions to leave a comment');
        
      }
    }
  };

  return (
    <div className="add-document-comment-footer">
      <div className="add-document-comment">
        <div className="add-document-comment__image">
        <UserAvatar user={user} />
        </div>
        <Form onSubmit={submitForm}>
  
          <div className="add-document-comment__field">
            <textarea
              placeholder={t('comments.leaveComment')}
              name="comment"
              id="comment"
              value={comment}
              rows="4"
             onChange={(e) => {
               setComment(e.target.value);
               setCommentError('')}
               
              }
              ref={(e) => {
                commentFocus.current = e;
              }}
              
            />
            <Button
              type="submit"
              className="add-comment-button"
              disabled={isButtonDisabled}
              onClick={(e) => {
                e.preventDefault();
                submitForm();
              }} 
            >
              {t('comments.submitComment')}
            </Button>
          
            {commentError.length > 0 && (
              <span className="error-message">{commentError}</span>
            )}
          </div>
       </Form>
      </div>
    </div>
  );
};

export default AddComments;
